import styled from 'styled-components'

export const ModalBodyWrapper = styled.div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
  max-width: 400px;
`
